module.exports = __webpack_public_path__ + "static/img/wealth_level_67.09ef4ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_67.png
// module id = c32l
// module chunks = 0